import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import SimpleModal from 'components/SimpleModal';
import Disclosure from 'components/Disclosure';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var PlainZipFileModal = function PlainZipFileModal(_ref) {
  var fileName = _ref.fileName,
    onConfirm = _ref.onConfirm,
    onCancel = _ref.onCancel;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsx(SimpleModal, {
    title: t('modal_upload_plain_zip_title'),
    subtitle: fileName,
    body: /*#__PURE__*/_jsxs(Stack, {
      spacing: "s",
      children: [t('modal_upload_plain_zip_message'), /*#__PURE__*/_jsxs(Disclosure.Provider, {
        children: [/*#__PURE__*/_jsx(Disclosure.Toggle, {
          children: t('modal_upload_plain_zip_disclosure_toggle')
        }), /*#__PURE__*/_jsx(Disclosure.Hidden, {
          children: /*#__PURE__*/_jsxs(Stack, {
            spacing: "s",
            mt: "s",
            mx: "s",
            children: [/*#__PURE__*/_jsx(Trans, {
              t: t,
              i18nKey: "modal_upload_plain_zip_info_microsite"
            }), /*#__PURE__*/_jsx(Trans, {
              t: t,
              i18nKey: "modal_upload_plain_zip_info_scorm"
            })]
          })
        })]
      })]
    }),
    buttons: [{
      label: t('actions_upload_new_file'),
      onClick: onCancel
    }, {
      label: t('actions_upload_as_zip'),
      onClick: onConfirm,
      variant: 'primary'
    }],
    onClose: onCancel
  });
};
export default PlainZipFileModal;